module.exports = {

    pipeFlowBg: {
        texture: '/img/partials/pipe-flow/pipe-flow-bg.jpg',
        scale: {
            x: '100%'
        }
    },

    pipeBig: {
        scale: {
            x: '100%'
        },
        position: {
            y: '16%'
        },
        texture: '/img/partials/pipe-flow/pipe-diag-top.png'
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/pipeFlow.js